import { privateCollection } from "@/mocks/comics";
import SectionHeader from "./SectionHeader";

export default function PrivateCollection() {
  return (
    <section id="编辑私藏" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="编辑私藏"
          eyebrowTone="primary"
          title={
            <>
              编辑私藏 <span className="text-primary-600">· 舍不得分享的压箱底</span>
            </>
          }
          subtitle="以下四部是编辑部自己书单里的私藏款，没有榜单逻辑，只有纯粹的喜欢。希望能成为你的收藏夹常客。"
        />

        <div className="flex flex-col gap-8">
          {privateCollection.map((comic, index) => {
            const reverse = index % 2 === 1;
            return (
              <article
                key={comic.id}
                className="grid overflow-hidden rounded-lg border border-background-200 bg-background-50 md:grid-cols-2"
              >
                <div
                  className={`relative aspect-[16/9] w-full overflow-hidden bg-background-200 md:aspect-auto ${
                    reverse ? "md:order-2" : ""
                  }`}
                >
                  <img
                    src={comic.cover}
                    alt={`${comic.title} 编辑私藏漫画封面`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-col justify-center gap-3 p-6 md:p-8">
                  <div className="flex items-center gap-3">
                    <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-black text-background-50">
                      {index + 1}
                    </span>
                    <span className="text-xs font-medium tracking-widest text-primary-600">{comic.genre}</span>
                    <span className="ml-auto text-xs text-foreground-500">{comic.rating} 分</span>
                  </div>
                  <h3 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">
                    《{comic.title}》
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{comic.summary}</p>
                  <p className="border-l-2 border-primary-300 pl-3 text-sm leading-relaxed text-foreground-700">
                    {comic.note}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {comic.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-md bg-primary-100 px-2.5 py-1 text-xs text-primary-700"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}